import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_EMAILS_SETTINGS: string = '[ecommerce Emails Settings] Load Ecommerce Emails Settings';
export const LOAD_ECOMMERCE_EMAILS_SETTINGS_SUCCESS: string = '[ecommerce Emails Settings] Load Ecommerce Emails Settings Success';
export const LOAD_ECOMMERCE_EMAILS_SETTINGS_FAIL: string = '[ecommerce Emails Settings] Load Ecommerce Emails Settings Fail';

export class LoadEcommerceEmailsSettings implements Action {
  readonly type: string = LOAD_ECOMMERCE_EMAILS_SETTINGS;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceEmailsSettingsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_EMAILS_SETTINGS_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceEmailsSettingsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_EMAILS_SETTINGS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceEmailsSettingsAction = LoadEcommerceEmailsSettings | LoadEcommerceEmailsSettingsSuccess | LoadEcommerceEmailsSettingsFail;
